export enum ButtonTypeEnum {
  Default = 'Default',
  Error = 'Error',
  Primary = 'Primary',
  Link = 'Link',
  Text = 'Text',
}
